module.exports = __webpack_public_path__ + "static/dummy-avatar-4788048f319dc48101678d9e69f5077e.png";